import { bool, node } from "prop-types";
import classnames from "classnames";
import { XCircleIcon } from "@heroicons/react/20/solid";

const Error = ({
  errorMessage,
  isRefresh,
  children = null,
  className,
  fullWidth,
  shouldDisplayChildren,
}) => {
  const reloadPage = () => {
    document.location.reload();
  };

  const errorClass = classnames({
    "flex border border-destructive-active rounded-md bg-destructive-light py-4 px-5": true,
    "w-full": fullWidth,
    "w-4/5  mx-auto": !fullWidth,
    "mt-28": !className?.includes('mt'),
    [className]: className
  });

  if (!errorMessage) {
    return children;
  }
  const errorToDisplay =
    typeof errorMessage === "string" ? errorMessage : errorMessage.toString();
  return (
    <>
      <div className={errorClass}>
        <div className="flex-shrink-0">
          <XCircleIcon className="h-5 w-5 text-destructive-light-foreground" aria-hidden="true" />
        </div>
        <div className="ml-5">
          <p className="text-base text-destructive-light-foreground">{errorToDisplay}</p>

          {isRefresh ? (
            <p
              onClick={reloadPage}
              className="text-base text-destructive-light-foreground font-semibold cursor-pointer transition ease-in-out duration-150 mt-8"
            >
              Refresh the page
            </p>
          ) : null}
        </div>
      </div>
      {shouldDisplayChildren && children}
    </>
  );
};

Error.propTypes = {
  children: node,
  isRefresh: bool,
  shouldDisplayChildren: bool,
};
Error.defaultProps = {
  children: null,
  isRefresh: false,
  errorMessage: false,
  shouldDisplayChildren: false,
};

export default Error;
